export const AtlassianAccessLogoNeutral = () => (
  <svg
    width="430"
    height="48"
    viewBox="0 0 430 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10.2888 19.2001C9.78882 18.6001 8.98882 18.7001 8.58882 19.4001L0.0888177 36.4001C-0.211182 37.0001 0.288818 37.8001 0.988818 37.8001H12.7888C13.1888 37.8001 13.4888 37.6001 13.6888 37.2001C16.2888 32.0001 14.6888 24.0001 10.2888 19.2001Z"
      fill="url(#paint0_linear_2305_11169)"
    />
    <path
      d="M16.4888 3.8002C11.7888 11.3002 12.0888 19.6002 15.1888 25.9002C18.2888 32.2002 20.6888 36.9002 20.8888 37.3002C21.0888 37.7002 21.3888 37.9002 21.7888 37.9002H33.5888C34.3888 37.9002 34.7888 37.1002 34.4888 36.4002C34.4888 36.4002 18.5888 4.6002 18.1888 3.8002C17.8888 3.0002 16.8888 3.0002 16.4888 3.8002Z"
      fill="#77859B"
    />
    <path
      d="M154.989 17.4001C154.989 21.6001 156.889 24.9001 164.589 26.4001C169.089 27.4001 170.089 28.1001 170.089 29.6001C170.089 31.1001 169.089 32.0001 165.889 32.0001C162.189 32.0001 157.789 30.7001 154.889 29.0001V35.8001C157.189 36.9001 160.189 38.2001 165.889 38.2001C173.889 38.2001 176.989 34.6001 176.989 29.4001M176.989 29.4001C176.989 24.4001 174.389 22.1001 166.889 20.5001C162.789 19.6001 161.789 18.7001 161.789 17.4001C161.789 15.8001 163.289 15.1001 165.989 15.1001C169.289 15.1001 172.489 16.1001 175.589 17.5001V11.0001C173.389 9.9001 170.089 9.1001 166.189 9.1001C158.789 9.1001 154.989 12.3001 154.989 17.5001"
      fill="#44546F"
    />
    <path
      d="M257.389 9.30029V37.8003H263.489V16.1003L265.989 21.9003L274.589 37.8003H282.189V9.30029H276.189V27.7003L273.889 22.4003L266.989 9.30029H257.389Z"
      fill="#44546F"
    />
    <path
      d="M218.789 9.30029H212.189V37.8003H218.789V9.30029Z"
      fill="#44546F"
    />
    <path
      d="M204.589 29.4001C204.589 24.4001 201.989 22.1001 194.489 20.5001C190.389 19.6001 189.389 18.7001 189.389 17.4001C189.389 15.8001 190.889 15.1001 193.589 15.1001C196.889 15.1001 200.089 16.1001 203.189 17.5001V11.0001C200.989 9.9001 197.689 9.1001 193.789 9.1001C186.389 9.1001 182.589 12.3001 182.589 17.5001C182.589 21.7001 184.489 25.0001 192.189 26.5001C196.689 27.5001 197.689 28.2001 197.689 29.7001C197.689 31.2001 196.689 32.1001 193.489 32.1001C189.789 32.1001 185.389 30.8001 182.489 29.1001V35.9001C184.789 37.0001 187.789 38.3001 193.489 38.3001C201.389 38.2001 204.589 34.7001 204.589 29.4001Z"
      fill="#44546F"
    />
    <path
      d="M103.589 9.30029V37.8003H117.189L119.289 31.7003H110.189V9.30029H103.589Z"
      fill="#44546F"
    />
    <path
      d="M76.6888 9.30029V15.5003H83.9888V37.8003H90.6888V15.5003H98.5888V9.30029H76.6888Z"
      fill="#44546F"
    />
    <path
      d="M66.9888 9.30029H58.2888L48.3888 37.8003H55.9888L57.3888 33.0003C59.0888 33.5003 60.8888 33.8003 62.6888 33.8003C64.4888 33.8003 66.2888 33.5003 67.9888 33.0003L69.3888 37.8003H76.9888C76.8888 37.8003 66.9888 9.30029 66.9888 9.30029ZM62.5888 27.9003C61.2888 27.9003 60.0888 27.7003 58.9888 27.4003L62.5888 15.0003L66.1888 27.4003C65.0888 27.7003 63.8888 27.9003 62.5888 27.9003Z"
      fill="#44546F"
    />
    <path
      d="M140.689 9.30029H131.989L121.989 37.8003H129.589L130.989 33.0003C132.689 33.5003 134.489 33.8003 136.289 33.8003C138.089 33.8003 139.889 33.5003 141.589 33.0003L142.989 37.8003H150.589L140.689 9.30029ZM136.289 27.9003C134.989 27.9003 133.789 27.7003 132.689 27.4003L136.289 15.0003L139.889 27.4003C138.789 27.7003 137.589 27.9003 136.289 27.9003Z"
      fill="#44546F"
    />
    <path
      d="M242.689 9.30029H233.989L224.089 37.8003H231.689L233.089 33.0003C234.789 33.5003 236.589 33.8003 238.389 33.8003C240.189 33.8003 241.989 33.5003 243.689 33.0003L245.089 37.8003H252.689L242.689 9.30029ZM238.389 27.9003C237.089 27.9003 235.889 27.7003 234.789 27.4003L238.389 15.0003L241.989 27.4003C240.889 27.7003 239.589 27.9003 238.389 27.9003Z"
      fill="#44546F"
    />
    <path
      d="M303.101 31.0001L300.601 37.8001H296.001L307.901 7.6001H313.101L325.001 37.8001H320.401L317.901 30.9001C315.201 31.5001 312.801 31.7001 310.401 31.7001C308.001 31.8001 305.701 31.5001 303.101 31.0001ZM316.601 27.5001L310.501 10.9001L304.401 27.5001C306.701 27.9001 308.501 28.1001 310.401 28.1001C312.301 28.1001 314.201 27.9001 316.601 27.5001Z"
      fill="#44546F"
    />
    <path
      d="M344.001 37.1999C342.601 37.8999 340.501 38.2999 338.401 38.2999C330.201 38.2999 326.401 33.2999 326.401 26.2999C326.401 19.3999 330.201 14.3999 338.401 14.3999C340.501 14.3999 342.101 14.6999 343.901 15.4999V19.1999C342.401 18.4999 340.901 18.0999 338.701 18.0999C332.701 18.0999 330.301 21.8999 330.301 26.2999C330.301 30.7999 332.801 34.4999 338.801 34.4999C341.101 34.4999 342.601 34.1999 344.001 33.6999V37.1999Z"
      fill="#44546F"
    />
    <path
      d="M364.701 37.1999C363.301 37.8999 361.201 38.2999 359.101 38.2999C350.901 38.2999 347.101 33.2999 347.101 26.2999C347.101 19.3999 350.901 14.3999 359.101 14.3999C361.201 14.3999 362.801 14.6999 364.601 15.4999V19.1999C363.101 18.4999 361.601 18.0999 359.401 18.0999C353.401 18.0999 351.001 21.8999 351.001 26.2999C351.001 30.7999 353.501 34.4999 359.501 34.4999C361.801 34.4999 363.301 34.1999 364.701 33.6999V37.1999Z"
      fill="#44546F"
    />
    <path
      d="M380.201 38.2999C371.601 38.2999 367.801 33.2999 367.801 26.2999C367.801 19.3999 371.701 14.3999 378.701 14.3999C385.801 14.3999 388.601 19.2999 388.601 26.2999V27.9999H371.801C372.401 31.8999 374.901 34.3999 380.301 34.3999C383.001 34.3999 385.201 33.8999 387.301 33.1999V36.7999C385.501 37.8999 382.601 38.2999 380.201 38.2999ZM371.801 24.5999H384.601C384.401 20.2999 382.401 17.8999 378.501 17.8999C374.401 17.8999 372.201 20.5999 371.801 24.5999Z"
      fill="#44546F"
    />
    <path
      d="M400.601 38.3C397.101 38.3 394.301 37.5 392.601 36.6V32.4C394.601 33.6 397.901 34.7 400.801 34.7C403.801 34.7 405.401 33.5 405.401 31.7C405.401 30 404.101 28.9 399.701 27.9C394.601 26.7 392.401 24.7 392.401 20.9C392.401 16.9 395.501 14.5 400.701 14.5C403.701 14.5 406.401 15.2 408.101 16.2V20.3C405.301 18.9 403.101 18.2 400.601 18.2C397.701 18.2 396.101 19.2 396.101 21C396.101 22.6 397.201 23.6 401.401 24.6C406.501 25.8 409.101 27.7 409.101 31.7C409.201 35.4 406.701 38.3 400.601 38.3Z"
      fill="#44546F"
    />
    <path
      d="M421.001 38.3C417.501 38.3 414.701 37.5 413.001 36.6V32.4C415.001 33.6 418.301 34.7 421.201 34.7C424.201 34.7 425.801 33.5 425.801 31.7C425.801 30 424.501 28.9 420.101 27.9C415.001 26.7 412.801 24.7 412.801 20.9C412.801 16.9 415.901 14.5 421.101 14.5C424.101 14.5 426.801 15.2 428.501 16.2V20.3C425.701 18.9 423.501 18.2 421.001 18.2C418.101 18.2 416.501 19.2 416.501 21C416.501 22.6 417.601 23.6 421.801 24.6C426.901 25.8 429.501 27.7 429.501 31.7C429.601 35.4 427.201 38.3 421.001 38.3Z"
      fill="#44546F"
    />
    <defs>
      <linearGradient
        id="paint0_linear_2305_11169"
        x1="14.9049"
        y1="21.8045"
        x2="5.94992"
        y2="37.3145"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#304566" />
        <stop offset="0.923" stopColor="#77859B" />
      </linearGradient>
    </defs>
  </svg>
);
